export default function Services() {
  const services = [
    {
      title: 'Dry Cleaning',
      description: 'Professional dry cleaning for delicate fabrics and formal wear with expert stain removal.',
      image: 'https://public.readdy.ai/ai/img_res/250c85730e603777b4476f8a539ed4b6.jpg',
      icon: 'ri-shirt-line'
    },
    {
      title: 'Wash & Fold',
      description: 'Convenient wash and fold service for everyday clothing with same-day turnaround available.',
      image: 'https://readdy.ai/api/search-image?query=Neatly%20folded%20fresh%20laundry%20stack%20with%20colorful%20casual%20clothing%20organized%20by%20type%2C%20professional%20folding%20technique%2C%20clean%20white%20surface%2C%20soft%20natural%20lighting%2C%20organized%20clothing%20care%20service%2C%20commercial%20photography%20showing%20texture%20and%20cleanliness%20with%20simple%20background&width=400&height=400&seq=service-002&orientation=squarish',
      icon: 'ri-t-shirt-line'
    },
    {
      title: 'Ironing & Pressing',
      description: 'Crisp, wrinkle-free results with professional pressing for shirts, pants, and linens.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20steam%20iron%20pressing%20white%20dress%20shirt%20on%20ironing%20board%2C%20close-up%20detail%20shot%2C%20commercial%20laundry%20equipment%2C%20clean%20minimalist%20setting%2C%20soft%20lighting%20highlighting%20fabric%20smoothness%2C%20high-end%20garment%20care%20service%2C%20simple%20white%20background%20with%20professional%20quality&width=400&height=400&seq=service-003&orientation=squarish',
      icon: 'ri-iron-line'
    },
    {
      title: 'Alterations & Repairs',
      description: 'Expert tailoring and repair services to extend the life of your favorite garments.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20tailor%20workspace%20with%20sewing%20machine%20and%20fabric%20samples%2C%20measuring%20tape%20and%20scissors%20on%20clean%20work%20surface%2C%20clothing%20alteration%20service%20setup%2C%20soft%20natural%20lighting%2C%20organized%20tailoring%20station%2C%20simple%20background%20highlighting%20craftsmanship%20tools%20and%20quality%20materials&width=400&height=400&seq=service-004&orientation=squarish',
      icon: 'ri-scissors-line'
    },
    {
      title: 'Pickup & Delivery',
      description: 'Free pickup and delivery service for your convenience. Schedule online or by phone.',
      image: 'https://readdy.ai/api/search-image?query=Delivery%20person%20holding%20clean%20laundry%20bags%20and%20garment%20bags%2C%20professional%20uniform%2C%20friendly%20service%20concept%2C%20clean%20white%20background%2C%20modern%20logistics%20service%2C%20organized%20clothing%20delivery%2C%20commercial%20photography%20style%20showing%20convenience%20and%20reliability&width=400&height=400&seq=service-005&orientation=squarish',
      icon: 'ri-truck-line'
    }
  ];

  return (
    <section id="services" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-16 gap-6">
          <div className="inline-block">
            <span className="text-sm font-medium text-white border border-white/30 px-5 py-2 rounded-full">
              Our Services
            </span>
          </div>
          <h2 className="text-4xl lg:text-6xl font-bold text-white lg:text-right max-w-2xl leading-tight">
            Professional Care<br />For Every Fabric
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-amber-50 rounded-2xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6 bg-slate-800">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 flex items-center justify-center bg-amber-600 rounded-lg">
                    <i className={`${service.icon} text-white text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-white">{service.title}</h3>
                </div>
                <div className="h-px bg-amber-600 mb-3"></div>
                <p className="text-gray-300 text-sm leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
